import React from 'react';
import language from '../language';

const CategorySelector = ({ setSelectedCategory, categories }) => {
    return (
        <div className="category-selector">
            <select onChange={(e) => setSelectedCategory(e.target.value)}>
                <option value="all">{language.allCategories}</option>
                {categories.map((category) => (
                    <option key={category} value={category}>
                        {category}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CategorySelector;